import * as React from "react";
import type { IPublicClientApplication } from "@azure/msal-browser";
import { App } from "App";
import { Routes } from "Routes";
import msalInstance, { msalReady } from "dev-auth";
import { startDevMockWorker } from "devMocks/worker";
import Environment from "environment";
import "global.less";
import { createRoot } from "react-dom/client";
import { envConfig } from "utils/envConfig";

declare let module: __WebpackModuleApi.Module;

type AppComponent = React.ComponentType<{ routes: React.ReactElement; msalInstance: IPublicClientApplication }>;

function render(Component: AppComponent) {
  const container = document.getElementById("app");
  if (container) {
    const root = createRoot(container);
    root.render(<Component routes={<Routes />} msalInstance={msalInstance} />);
  }
}

async function initialize() {
  if (Environment.isInDevelopmentMode() && envConfig.UseDevMsw) {
    await startDevMockWorker();
  }

  await msalReady;
  render(App);
}

initialize();

//Do NOT move to a separate file as this wil break hot reloading
if (module.hot) {
  module.hot.accept("./App", () => {
    try {
      const NextApp = require("./App").App;
      render(NextApp);
    } catch (err) {
      console.error("Error updating app", err);
    }
  });
}
